//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["historys"],
  methods: {
    historyGo(item) {
      this.$emit("historyGo", item);
    },
    strLen(str) {
      if (str.length > 15) {
        return str.slice(0, 15) + "...";
      } else {
        return str;
      }
    }
  },
  mounted() {}
};
